import { connect } from 'react-redux';
import {
  updateAccountPlayers,
  enqueueAccountPlayersCSVReport,
  enqueueUserActionsCSVReport,
} from '../../actions/partner';
import { apColumnsVisibilityChanged, showBulkSendingModal, showReportDetailsModal } from '../../actions/internal';
import AccountPlayersFilter from '../../components/filters/AccountPlayersFilter';
import { getAccountsIndexedOptions, getCohorts, getSubgroups } from '../../selectors';
import _ from 'lodash';
import { getLoaders } from '../../selectors';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    meta: state.meta.accountPlayers,
    accounts: state.filters.accounts,
    cohorts: getCohorts(state),
    subgroups: getSubgroups(state),
    download: state.filters.download,
    csvReport: state.accountPlayersCSVReport,
    userActionsCSVReport: state.userActionsCSVReport,
    groups: state.filters.groups,
    options: state.options.apColumns,
    partners: state.filters.partners,
    withScope: state.filters.withScope,
    filterOptions: getAccountsIndexedOptions(state.filters),
    isLoading: getLoaders(state, [
      'ACCOUNT_PLAYERS_FILTER',
      'ACCOUNT_PLAYERS',
    ]),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAccountChange: (accounts) => {
      dispatch(updateAccountPlayers({accounts, page: 1}))
    },
    onArchivedChange: (value) => {
      dispatch(updateAccountPlayers({archived: value, page: 1}))
    },
    onBulkSend: () => {
      dispatch(showBulkSendingModal());
    },
    onSubgroupChange: (subgroups) => {
      dispatch(updateAccountPlayers({subgroups: subgroups, page: 1}));
    },
    onCohortChange: (cohorts) => {
      dispatch(updateAccountPlayers({cohorts: cohorts, page: 1}));
    },
    onDatesChange: (startDate, endDate) => {
      dispatch(updateAccountPlayers({start: startDate, end: endDate, page: 1}));
    },
    onColumnVisibilityChange: (value) => {
      if (value.length) dispatch(apColumnsVisibilityChanged(value));
    },
    onCSVEnqueue: _.debounce(() => {
      dispatch(enqueueAccountPlayersCSVReport());
    }, 500),
    onUserActionsCSVEnqueue: _.debounce(() => {
      dispatch(enqueueUserActionsCSVReport());
    }, 500),
    onReportDetailsShow: (report) => {
      dispatch(showReportDetailsModal(report, 'ACCOUNT_PLAYERS_REPORT_DETAILS'));
    },
    onUserActionsReportDetailsShow: (report) => {
      dispatch(showReportDetailsModal(report, 'USER_ACTIONS_REPORT_DETAILS'));
    },
    onGroupChange: (groups) => {
      dispatch(updateAccountPlayers({groups, page: 1}))
    },
    onPartnerChange: (partners) => {
      dispatch(updateAccountPlayers({partners, page: 1}))
    },
    onSearch: (q) => {
      dispatch(updateAccountPlayers({q, page: 1}))
    },
    onUnreadChange: (value) => {
      dispatch(updateAccountPlayers({unread: value, page: 1}))
    },
  }
}

const AccountsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountPlayersFilter)

export default AccountsFilterContainer;
